import { SvgIcon, SvgIconProps } from "@mui/material";

export const AlignmentRightIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <rect
        width="18"
        height="18"
        x="21"
        y="21"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        rx="5"
        transform="rotate(-180 21 21)"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M12 15.5h4.5M16.5 8.5h-9M7.5 12h9"
      />
    </svg>
  </SvgIcon>
);
